<template>
  <a-modal
    class="clamp-edit"
    centered
    width="720px"
    title="编辑"
    :visible="isEdit"
    @cancel="_close(null)"
    wrapClassName="clamp-modal"
  >
    <template #footer>
      <div class="btn" v-show="curIndex === 0">
        <a-button class="cancel" @click="_close(null)">取消</a-button>
        <a-button class="sure" @click="_sure">确定</a-button>
      </div>
    </template>
    <div class="title">
      <div
        class="title-item"
        v-for="(item, index) in tabs"
        :key="index"
        @click="curIndex = index"
        :class="curIndex === index ? 'active' : ''"
      >
        {{ item }}
      </div>
      <div class="add" @click="_addRPS" :class="curIndex === 2 ? 'block' : ''">
        <div class="iconfont icon-a-tianjia"></div>
      </div>
    </div>
    <div v-if="curIndex === 0" class="clamp-info">
      <div class="clamp-info-tr">
        <div class="td">
          <div class="text">夹具名称：</div>
          <a-input v-model="curClamp.clampName" />
        </div>
        <div class="td">
          <div class="text">车身区域：</div>
          <a-select v-model="curClamp.bodyAreaId">
            <a-select-option v-for="item in areas" :key="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="clamp-info-tr">
        <div class="td">
          <div class="text">厂家：</div>
          <a-select v-model="curClamp.standardId">
            <a-select-option v-for="item in standards" :key="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </div>
        <div class="td">
          <div class="text">气缸个数：</div>
          <a-input type="number" v-model="curClamp.cylinderSize"></a-input>
        </div>
      </div>
      <div class="clamp-info-tr">
        <div class="td">
          <div class="text">工艺类型：</div>
          <a-select v-model="curClamp.processTypeId">
            <a-select-option v-for="item in processTypes" :key="item.id">{{ item.name }}</a-select-option>
          </a-select>
        </div>
        <div class="td">
          <div class="text">缩略图：</div>
          <div class="img">
            <img :src="curClamp.imgUrl" alt="" />
          </div>
        </div>
      </div>
      <div class="clamp-info-tr">
        <div class="td">
          <div class="text">Product文件：</div>
          <div class="content">
            <a-button class="download" @click="_down(curClamp.clampProductFileAddress)">下载</a-button>
          </div>
        </div>
        <div class="td"></div>
      </div>
      <div class="clamp-info-tr">
        <div class="td">
          <div class="text">工件STL：</div>
          <div class="content">
            <a-button class="download" @click="_down(curClamp.workStlFileAddress)">下载</a-button>
          </div>
        </div>
        <div class="td">
          <div class="text">工件STP：</div>
          <div class="content">
            <a-button class="download" @click="_down(curClamp.workStpFileAddress)">下载</a-button>
          </div>
        </div>
      </div>
      <div class="clamp-info-tr">
        <div class="td">
          <div class="text">上传人：</div>
          <div class="content">{{ curClamp.creator }}</div>
        </div>
        <div class="td">
          <div class="text">上传时间：</div>
          <div class="content">{{ curClamp.createDate }}</div>
        </div>
      </div>
      <div class="clamp-info-tr">
        <div class="td">
          <div class="text">修改人：</div>
          <div class="content">{{ curClamp.modifier }}</div>
        </div>
        <div class="td">
          <div class="text">修改时间：</div>
          <div class="content">{{ curClamp.modifyDate }}</div>
        </div>
      </div>
    </div>
    <div v-if="curIndex === 1" class="rps-info">
      <a-table
        class="table-list"
        :columns="partColumns"
        :data-source="curClamp.partList"
        :row-selection="rowPartSelection"
        :pagination="false"
        :scroll="{ y: 300 }"
      >
        <template slot="partName" slot-scope="text, record">
          <a-input v-if="record.flag" v-model="record.partName"></a-input>
          <span v-else>{{ record.partName }}</span>
        </template>
        <template slot="partTypeId" slot-scope="text, record">
          <a-select v-if="record.flag" v-model="record.partTypeId">
            <a-select-option v-for="item in partTypes" :key="item.id">{{ item.name }}</a-select-option>
          </a-select>
          <span v-else>{{
            partTypes.find((item) => item.id === record.partTypeId)
              ? partTypes.find((item) => item.id === record.partTypeId).name
              : '暂无'
          }}</span>
        </template>
        <!-- <template v-slot:partTagName="rows">
                  <a-select v-if="rows.record.flag" class="directorys" v-model:value="rows.record.partTagId">
                      <a-select-option v-for="item in directorys" :key="item.configId">{{ item.name }}</a-select-option>
                  </a-select>
                  <div>{{ directorys }}</div>
                  <a-cascader
                      v-if="rows.record.flag"
                      v-model:value="rows.record.partTagId"
                      :options="directorys"
                      change-on-select
                      placeholder="请选择"
                      class="directorys"
                      :fieldNames="{ value: 'configId', label: 'name', children: 'children' }"
                      @change="_change"
                  ></a-cascader>
                  <span v-else>{{ rows.record.partTagName || '暂无' }} </span>
              </template> -->
        <template slot="operation" slot-scope="text, record">
          <span class="iconfont icon-eye icon-a-xianshi1" @click="_modalPreview(record)"></span>
          <span v-if="!record.flag" class="iconfont icon-edit icon-bianji" @click="_edit(record)"></span>
          <span v-if="record.flag" class="iconfont icon-edit icon-duihao" @click="_surePart(record)"></span>
          <span class="iconfont icon-del icon-shanchu" @click="_delPart(record)"></span>
        </template>
      </a-table>
      <a-button type="primary" class="modal-preview" @click="_dataPreview()">夹具预览</a-button>
    </div>
    <div v-if="curIndex === 2" class="rps-info">
      <a-table
        :columns="rpsColumns"
        :data-source="curClamp.rpss"
        :row-selection="rowSelection"
        :pagination="false"
        :scroll="{ y: 300 }"
      >
        <template slot="operation" slot-scope="text, record">
          <span v-if="!record.flag" class="iconfont icon-edit icon-bianji" @click="_edit(record)"></span>
          <span v-if="record.flag" class="iconfont icon-edit icon-duihao" @click="_ok()"></span>
          <span class="iconfont icon-del icon-shanchu" @click="_del(record)"></span>
        </template>
        <template slot="Name" slot-scope="text, record">
          <a-input v-if="record.flag" v-model="record.Name"></a-input>
          <span v-else>{{ record.Name }}</span>
        </template>
        <template slot="Type" slot-scope="text, record">
          <a-select v-if="record.flag" v-model="record.Type">
            <a-select-option v-for="item in rpsTypes" :key="item.name">{{ item.name }}</a-select-option>
          </a-select>
          <span v-else>{{ record.Type }}</span>
        </template>
      </a-table>
    </div>
    <div class="detail-iframe-container" v-show="modalFrameVisible">
      <div
        class="icon-delete"
        @click="
          () => {
            modalFrameVisible = false
          }
        "
      >
        ×
      </div>
      <iframe
        :allow-same-origin="`${originFrameUrl}`"
        v-show="modalFrameVisible"
        class="detail-iframe"
        ref="detail_iframe"
        :src="`${modalFrameUrl}`"
        scrolling="no"
        frameborder="0"
      >
      </iframe>
    </div>
  </a-modal>
</template>
<script>
import { message } from 'ant-design-vue'
import { editClampInfo, editPart, delPart } from '@/api/api'
import { UploadFileService } from '@/utils/oss/upload_service'
export default {
  data() {
    return {
      curIndex: 0,
      tabs: ['夹具详情', '零件列表', 'RPS点'],
      partColumns: [
        {
          title: '序号',
          dataIndex: 'index',
          align: 'center',
        },
        {
          title: '零件名称',
          dataIndex: 'partName',
          scopedSlots: { customRender: 'partName' },
          align: 'center',
        },
        {
          title: '零件分类',
          dataIndex: 'partTypeId',
          scopedSlots: { customRender: 'partTypeId' },
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operate',
          align: 'center',
          scopedSlots: { customRender: 'operation' },
        },
      ],
      rpsColumns: [
        {
          title: '序号',
          dataIndex: 'Index',
          align: 'center',
          scopedSlots: { customRender: 'Index' },
        },
        {
          title: '点名称',
          dataIndex: 'Name',
          scopedSlots: { customRender: 'Name' },
          align: 'center',
        },
        {
          title: '点类型',
          dataIndex: 'Type',
          scopedSlots: { customRender: 'Type' },
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          align: 'center',
        },
      ],
      rowPartSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(selectedRowKeys, selectedRows)
        },
      },
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(selectedRowKeys, selectedRows)
        },
      },
      modalFrameVisible: false,
      modalFrameUrl: '',
      originFrameUrl: '',
    }
  },
  props: {
    isEdit: {
      type: Boolean,
    },
    areas: {
      type: Array,
    },
    standards: {
      type: Array,
    },
    processTypes: {
      type: Array,
    },
    partTypes: {
      type: Array,
    },
    rpsTypes: {
      type: Array,
    },
    curClamp: {
      type: Object,
    },
  },
  methods: {
    _close(flag) {
      this.$emit('closeEdit', flag)
    },
    _down(url) {
      if (url) {
        window.open(url)
      } else {
        message.warn('下载地址为空')
      }
    },
    // 修改夹具详情
    async _sure() {
      const { clampId, clampName, bodyAreaId, standardId, processTypeId, cylinderSize } = this.curClamp
      const { code, msg } = await editClampInfo({
        clampId,
        clampName,
        bodyAreaId,
        standardId,
        processTypeId,
        cylinderSize: Number(cylinderSize),
      })
      if (code === 200) {
        message.success(msg)
        this.$emit('closeEdit', true)
      }
    },
    _addRPS() {
      const newRps = {
        Index: this.curClamp.rpss.length + 1,
        key: this.curClamp.rpss.length + 1,
        Name: '',
        Type: '',
        flag: true,
      }
      this.curClamp.rpss.push(newRps)
    },
    _edit(record) {
      record.flag = true
    },
    _modalPreview(record) {
      this.modalFrameVisible = true
      this.modalFrameUrl = `${window.ENV_CONFIG['modelLoaderUrl']}`
      this.originFrameUrl = `${window.ENV_CONFIG['homePageUrl']}`
      const m = (matrix) => {
        const arrayStr = matrix.substring(1, matrix.length - 1)
        const arr = arrayStr.split(',').map((s) => Number(s))
        return arr
      }
      const receive = { id: record.key, glb: record.partGlbFileAddress, matrix: m(record.matrix) }
      // window.frames[0].postMessage([receive])
      const mapFrame = this.$refs['detail_iframe']
      // const mapFrame = document.getElementsByClassName('detail-iframe')[0]
      const iframeWin = mapFrame.contentWindow
      console.log(iframeWin)
      if (iframeWin) {
        iframeWin.postMessage({ models: [receive] }, this.modalFrameUrl)
      }
    },
    _dataPreview() {
      const m = (matrix) => {
        const arrayStr = matrix.substring(1, matrix.length - 1)
        const arr = arrayStr.split(',').map((s) => Number(s))
        return arr
      }

      const receives = []

      if (this.curClamp.gunGltfFileAddress) {
        receives.push({
          id: this.curClamp.clampId,
          glb: this.curClamp.gunGltfFileAddress,
          matrix: m(this.curClamp.matrix),
        })
      }

      for (const c of this.curClamp.partList) {
        const receive = { id: c.key, glb: c.partGlbFileAddress, matrix: m(c.matrix) }
        receives.push(receive)
      }

      this.modalFrameVisible = true
      this.modalFrameUrl = `${window.ENV_CONFIG['modelLoaderUrl']}`

      const mapFrame = this.$refs['detail_iframe']
      const iframeWin = mapFrame.contentWindow

      if (iframeWin) {
        iframeWin.postMessage({ models: receives }, this.modalFrameUrl)
      }
    },
    // 修改零件信息
    async _surePart(record) {
      const { code, msg } = await editPart({
        clampId: this.curClamp.clampId,
        partId: record.partId,
        partName: record.partName,
        partTypeId: record.partTypeId,
      })
      if (code === 200) {
        message.success(msg)
        this.$emit('closeEdit', true)
      }
    },
    // 删除零件
    async _delPart(record) {
      const { code, msg } = await delPart({ historyPartIds: [record.partId] })
      if (code === 200) {
        message.success(msg)
        this.$emit('closeEdit', true)
      }
    },
    async _ok(a) {
      const arr = this.curClamp.rpsInfo.split('/')
      const type = this.curClamp.rpsInfo.split('.')
      const info = a || this.curClamp.rpss
      const blob = new Blob([JSON.stringify(info)], { type: type[type.length - 1] })
      const file = new File([blob], arr[arr.length - 1])
      const { fileAddress } = await UploadFileService.uploadFile2(file, this.curClamp.rpsInfo)
      if (fileAddress) {
        const { code, msg } = await editClampInfo({ clampId: this.curClamp.clampId, rpsInfo: fileAddress })
        if (code === 200) {
          message.success(msg)
          this.$emit('closeEdit', true)
        }
      }
    },
    _del(record) {
      const index = this.curClamp.rpss.findIndex((item) => item.Index === record.Index)
      const rpsCopy = [...this.curClamp.rpss]
      rpsCopy.splice(index, 1)
      this._ok(rpsCopy)
    },
  },
}
</script>
<style lang="less">
@import './edit.less';
</style>
